const IS_DEV = true;
const DEBUG_ACK = IS_DEV;

const IS_ANALYTICS_ENABLED = true;

let messageId = 0;
const pendingAcks = new Map();

const nativeCapabilities = new Set();
let nativeReadyResolve;
let handshakeEstablished = false;
let nativeBridgeDisabled = false;
const nativeReadyPromise = new Promise((resolve) => {
  nativeReadyResolve = resolve;
});

const NATIVE_READY_TIMEOUT = 4000;
setTimeout(() => {
  if (!handshakeEstablished) {
    nativeBridgeDisabled = true;
    if (IS_DEV) console.warn('[Bridge] Handshake con RN no se estableció a tiempo. Se deshabilitan los envíos por postMessage.');
  }
  nativeReadyResolve?.(false);
}, NATIVE_READY_TIMEOUT);

const handleIncomingMessage = (raw) => {
  try {
    const data = typeof raw === 'string' ? JSON.parse(raw) : raw;
    if (!data) return;

    if (data.type === 'native_ready' && Array.isArray(data.supports)) {
      data.supports.forEach((cap) => nativeCapabilities.add(cap));
      handshakeEstablished = true;
      nativeBridgeDisabled = false;
      nativeReadyResolve?.(true);

      if (DEBUG_ACK) {
        console.log('native_ready recibido');
      }
      return;
    }

    if (data.type === 'ack' && data._id && pendingAcks.has(data._id)) {
      const { resolve, timer } = pendingAcks.get(data._id);
      clearTimeout(timer);
      pendingAcks.delete(data._id);
      resolve(true);

      if (DEBUG_ACK) {
        console.log('ACK recibido de RN');
      }
    }
  } catch (e) {
    console.error('Error al manejar el mensaje entrante:', e);
  }
};

document.addEventListener('message', (e) => handleIncomingMessage(e.data));
window.addEventListener('message', (e) => handleIncomingMessage(e.data));
window.onNativeMessage = (msg) => handleIncomingMessage(msg);

const sendToNative = (payload, { withAck = false, timeout = 3000 } = {}) => {
  return new Promise((resolve) => {
    if (nativeBridgeDisabled) {
      if (IS_DEV) console.warn('[Bridge] Envío omitido: el bridge está deshabilitado (handshake no establecido).');
      return resolve(false);
    }

    try {
      const isWebView = window.ReactNativeWebView && typeof window.ReactNativeWebView.postMessage === 'function';

      if (!isWebView) {
        if (IS_DEV) console.warn('ReactNativeWebView.postMessage no está disponible.');
        return resolve(false);
      }

      if (!withAck) {
        window.ReactNativeWebView.postMessage(JSON.stringify(payload));
        return resolve(true);
      }

      const id = `msg_${Date.now()}_${messageId++}`;
      const timer = setTimeout(() => {
        pendingAcks.delete(id);

        if (DEBUG_ACK) {
          console.log('Sin respuesta de RN');
        } else {
          console.warn('No se recibió confirmación de RN para el evento', id);
        }
        resolve(false);
      }, timeout);

      pendingAcks.set(id, { resolve, timer });
      window.ReactNativeWebView.postMessage(JSON.stringify({ ...payload, _id: id }));
    } catch (error) {
      console.error('Error enviando mensaje a Native:', error);
      resolve(false);
    }
  });
};

const ALLOWED_PARENT_ORIGINS = [
  'https://bdkb-055.my.commercecloud.salesforce.com',
  'https://bdkb-106.my.commercecloud.salesforce.com',
  'https://098.d-ph-ironflow.com',
  'https://dev.elpalaciodehierro.com',
  'http://stg.elpalaciodehierro.com',
  'https://elpalaciodehierro.com',
  'https://www.elpalaciodehierro.com',
];

function getTrustedParentOrigin() {
  try {
    if (document.referrer) {
      const referrerOrigin = new URL(document.referrer).origin;
      if (ALLOWED_PARENT_ORIGINS.includes(referrerOrigin)) {
        return referrerOrigin;
      }
    }
  } catch (error) {
    if (IS_DEV) console.warn('[Bridge] No se pudo parsear document.referrer:', error);
  }
  return null;
}

const sendOmnichannelAnalytics = async (payload) => {

  if (!IS_ANALYTICS_ENABLED) {
    if (IS_DEV) console.log('[Bridge] Analytics apagado temporalmente (Feature Flag).');
    return false;
  }

  const isAppWebView = window.ReactNativeWebView && typeof window.ReactNativeWebView.postMessage === 'function';

  if (isAppWebView) {
    await nativeReadyPromise;
    if (nativeBridgeDisabled || !nativeCapabilities.has('analytics_event')) {
      if (IS_DEV) console.log('[Bridge] Analytics omitido — handshake no establecido o RN no reporta soporte.');
      return false;
    }
    return sendToNative(payload, { withAck: true });
  }

  const isWebIframe = window.parent && window.parent !== window;

  if (isWebIframe) {
    const targetOrigin = getTrustedParentOrigin();

    if (!targetOrigin) {
      if (IS_DEV) console.warn('[Bridge] Origin del parent no está en la whitelist. Mensaje NO enviado.', document.referrer);
      return false;
    }

    try {
      window.parent.postMessage(payload, "*");
      if (IS_DEV) console.log('[Bridge] Evento enviado a Web Parent', payload);
      return true;
    } catch (error) {
      console.error('Error enviando mensaje a Web Parent:', error);
      return false;
    }
  }

  if (IS_DEV) {
    console.log('[Bridge-Local] Evento trackeado localmente:', payload);
  }
  return true;
};

const trackGnpEvent = (screen_name, interaction_name, extraParams = {}) => {
  const payload = {
    type: "analytics_event",
    event: "interaccion_gnp",
    params: {
      flow_name: "cotizacion_auto",
      screen_name,
      interaction_name,
      ...extraParams,
    },
  };

  return sendOmnichannelAnalytics(payload);
};

export const trackEventStep1View = () => trackGnpEvent("step 1 gnp", "vista step 1");
export const trackEventStep1Quote = () => trackGnpEvent("step 1 gnp", "cotizar");

export const trackEventErrorStep1View = (titulo, codigo, desc) =>
  trackGnpEvent("error step 1 gnp", "vista error", { nombre_incidencia: titulo, codigo_error: codigo, error_value: desc });
export const trackEventErrorStep1Retry = (titulo, codigo, desc) =>
  trackGnpEvent("error step 1 gnp", "reintentar", { nombre_incidencia: titulo, codigo_error: codigo, error_value: desc });
export const trackEventErrorStep1Call = (titulo, codigo, desc) =>
  trackGnpEvent("error step 1 gnp", "llamar", { nombre_incidencia: titulo, codigo_error: codigo, error_value: desc });
export const trackEventErrorStep1Close = (titulo, codigo, desc) =>
  trackGnpEvent("error step 1 gnp", "cerrar", { nombre_incidencia: titulo, codigo_error: codigo, error_value: desc });

export const trackEventStep2View = () => trackGnpEvent("step 2 gnp", "vista step 2");
export const trackEventStep2Select = (itemName) => trackGnpEvent("step 2 gnp", "elegir y continuar", { item_name: itemName });

export const trackEventErrorStep2View = (titulo, codigo, desc) =>
  trackGnpEvent("error step 2 gnp", "vista error", { nombre_incidencia: titulo, codigo_error: codigo, error_value: desc });
export const trackEventErrorStep2Retry = (titulo, codigo, desc) =>
  trackGnpEvent("error step 2 gnp", "reintentar", { nombre_incidencia: titulo, codigo_error: codigo, error_value: desc });

export const trackEventStep3View = () => trackGnpEvent("step 3 gnp", "vista step 3");
export const trackEventStep3Continue = () => trackGnpEvent("step 3 gnp", "continuar");

export const trackEventErrorStep3View = (titulo, codigo, desc) =>
  trackGnpEvent("step 3 gnp", "vista error", { nombre_incidencia: titulo, codigo_error: codigo, error_value: desc });

export const trackEventStep4View = () => trackGnpEvent("step 4 gnp", "vista step 4");
export const trackEventStep4Exit = () => trackGnpEvent("step 4 gnp", "salir y continuar mas tarde");
export const trackEventStep4Palacio = () => trackGnpEvent("step 4 gnp", "contratar y pagar con tarjeta palacio");
export const trackEventStep4Other = () => trackGnpEvent("step 4 gnp", "contratar con otro medio de pago");

export const trackEventConfirmPalacioContinue = () => trackGnpEvent("confirmacion step 4 gnp tarjeta palacio", "continuar y pagar");
export const trackEventConfirmPalacioExit = () => trackGnpEvent("confirmacion step 4 tarjeta palacio gnp", "salir");

export const trackEventConfirmOtherCall = () => trackGnpEvent("confirmacion step 4 otro medio gnp", "llamar");
export const trackEventConfirmOtherClose = () => trackGnpEvent("confirmacion step 4 otro medio gnp", "cerrar");

export const trackEventErrorConfirmView = () => trackGnpEvent("error confirmacion step 4 gnp", "vista error");
export const trackEventErrorConfirmCall = () => trackGnpEvent("error confirmacion step 4 gnp", "llamar");
export const trackEventErrorConfirmClose = () => trackGnpEvent("error confirmacion step 4 gnp", "cerrar");